import React, { useContext } from 'react';
import { FlowContext } from '../../core/flow-engine';
import NonToraConfirmation from './NonToraConfirmation';
import ToraConfirmation from './ToraConfirmation';
import RolloverConfirmation from './RolloverConfirmation';
import DirectRolloverRPSConfirmation from './DirectRolloverRPSConfirmation';
import IndirectRolloverConfirmation from './IndirectRolloverConfirmation';
import TrustConfirmation from './TrustConfirmation';

import { disqualifiedByCusip } from './util';
import {
  accountTypes,
  isTrust,
  rolloverTypes,
  isTaxableTransfer
} from '../../flows/shared/utils';
import TaxableTransferConfirmation from './TaxableTransferConfirmation';

const ConfirmationSection = () => {
  const { appState } = useContext(FlowContext);

  const {
    store: {
      toraParticipant,
      custodianCustomerServicePhone,
      loadedData,
      accountType,
      chargeType,
      rolloverType,
      rpsDirectRollover,
      app: { externalAccounts, custodian, fundingMethodType }
    }
  } = appState;

  const custodianName = custodian?.custodianName || '';

  const notDisqualifiedByCusip = !disqualifiedByCusip(externalAccounts);
  const isRollover = accountType === accountTypes.ROLLOVER;

  const isDirectRollover = rolloverType === rolloverTypes.DIRECT;

  /* eslint-disable react/no-unstable-nested-components */
  const TransferContents = () => {
    if (isTaxableTransfer(accountType, chargeType))
      return <TaxableTransferConfirmation loadedData={loadedData} />;

    return toraParticipant && notDisqualifiedByCusip ? (
      <ToraConfirmation
        custodianName={custodianName}
        custodianCustomerServicePhone={custodianCustomerServicePhone}
      />
    ) : (
      <NonToraConfirmation loadedData={loadedData} />
    );
  };

  /* eslint-disable react/no-unstable-nested-components */
  const RolloverContents = () => {
    if (rpsDirectRollover) {
      return <DirectRolloverRPSConfirmation />;
    }
    return isDirectRollover ? (
      <RolloverConfirmation custodianName={custodianName} />
    ) : (
      <IndirectRolloverConfirmation appState={appState} />
    );
  };

  if (isTrust(accountType)) {
    return (
      <TrustConfirmation
        loadedData={loadedData}
        fundingMethodType={fundingMethodType}
      />
    );
  }

  return isRollover ? <RolloverContents /> : <TransferContents />;
};

export default ConfirmationSection;
